import { computed, getCurrentInstance, onMounted } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useFundraisingGoalUpdated from "@/hooks/useFundraisingGoalUpdated";
import config from "@/config";

export default function useMyFundraisingGoalUpdated() {
  if (config.featureFundraisingGoals) {
    const { authUser, isCreator } = useAuthUser();
    const vm = getCurrentInstance();
    const routeNames = ["goals", "goalsById"];

    const userId = computed(() => {
      return isCreator.value && routeNames.includes(vm?.$route?.name ?? "") ? authUser.value?.id : null;
    });

    onMounted(() => {
      useFundraisingGoalUpdated(userId);
    });
  }
}
